import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TabItem } from './tab-item.model';
import { MixpanelService } from '@shared/services';
import { SessionService, PersonalLoansSessionDataModel } from '@shared/services/session';
import { camelCaseToTitleCase} from '@app/utils';

@Component({
  selector: 'ld-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.css']
})
export class TabsComponent implements OnInit {
  @Input() tabs: TabItem<any>[];
  @Output() tabSelected: EventEmitter<any> = new EventEmitter();

  private plData: PersonalLoansSessionDataModel;

  constructor(
    private mixpanel: MixpanelService,
    private sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.plData = this.sessionService.personalLoanSession.data;
  }

  updateSelectedTab(selectedTab: TabItem<any>): void {
    if (this.tabs) {
      this.tabs.forEach(tab => {
        tab.isActive = false;
      });
    }

    this.logAnalytics(selectedTab);
    selectedTab.isActive = true;
    this.tabSelected.emit(selectedTab);
  }

  private logAnalytics(tab: TabItem<any>) {
    this.mixpanel.track('Tab Changed PBU', {
      Product: 'P',
      User: 'B',
      Experience: 'U',
      Definition: 'Tab Clicked',
      'Tab Name': tab.label,
      'Loan Number': this.plData.loanNumber ? this.plData.loanNumber.toString() : '',
      'Loan Purpose': camelCaseToTitleCase(this.plData.loanPurpose ? this.plData.loanPurpose.toString() : ''),
      'Loan Status': camelCaseToTitleCase(this.plData.loanState ? this.plData.loanState.toString() : ''),
      'Lead ID': this.plData.loanApplicationGuid
    });
  }
}
